import { useEffect } from 'react'
import { initDatadogLog, setupMaintenance } from '@astronautsid/wpe-utils'
import { initializeApp } from 'firebase/app'
import { getRemoteConfig } from 'firebase/remote-config'

const {
  REACT_APP_DATADOG_CLIENT_TOKEN,
  REACT_APP_DATADOG_SITE,
  REACT_APP_DATADOG_SESSION_SAMPLE_RATE,
  REACT_APP_NODE_ENV,
  REACT_APP_VERSION,
  REACT_APP_NAME,
  REACT_APP_ENABLE_DATADOG,
  REACT_APP_ENABLE_REMOTE_CONFIG_MAINTENANCE,
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_STORAGE_BUCKET,
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  REACT_APP_FIREBASE_APP_ID,
  NODE_ENV,
} = process.env

const appFirebase = initializeApp({
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: REACT_APP_FIREBASE_APP_ID,
})

const remoteConfig = getRemoteConfig(appFirebase)

const useAppInit = () => {
  useEffect(() => {
    if (REACT_APP_ENABLE_DATADOG === 'true') {
      initDatadogLog({
        clientToken: REACT_APP_DATADOG_CLIENT_TOKEN as string,
        site: REACT_APP_DATADOG_SITE,
        forwardErrorsToLogs: false,
        sessionSampleRate: Number(REACT_APP_DATADOG_SESSION_SAMPLE_RATE),
        env: REACT_APP_NODE_ENV === 'production' ? 'production' : 'development',
        service: REACT_APP_NAME,
        version: REACT_APP_VERSION,
      })
    }
  }, [])

  useEffect(() => {
    if (NODE_ENV === 'development' || REACT_APP_ENABLE_REMOTE_CONFIG_MAINTENANCE !== 'true') return

    const unsub = setupMaintenance(remoteConfig)
    return () => unsub()
  }, [])
}

export default useAppInit
